import { Container, Grid2 } from "@mui/material";
// import { useEffect, useState } from "react";

// Target Date: Oct 11, 2025
// const targetDate = new Date("2025-10-11T00:00:00");

const Banner = () => {
  // const [timeLeft, setTimeLeft] = useState(getTimeRemaining());

  // Function to calculate remaining time
  // function getTimeRemaining() {
  //   const total = targetDate - new Date();
  //   const seconds = Math.floor((total / 1000) % 60);
  //   const minutes = Math.floor((total / 1000 / 60) % 60);
  //   const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
  //   const days = Math.floor(total / (1000 * 60 * 60 * 24));
  //   return { total, days, hours, minutes, seconds };
  // }

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setTimeLeft(getTimeRemaining());
  //   }, 1000);

  //   return () => clearInterval(timer);
  // }, []);

  // const units = [
  //   { label: "Days", value: timeLeft.days },
  //   { label: "Hours", value: timeLeft.hours },
  //   { label: "Minutes", value: timeLeft.minutes },
  //   { label: "Seconds", value: timeLeft.seconds }
  // ];

  return (
    <section className="mainBanner">
      <Container fixed>
        <Grid2 container>
          <Grid2 md={5}>
            {/* <div className="content">
              <h1>CodeWeek 2025</h1>
              <p className="date">October 11th - 26th</p>
              <div className="countdown">
                {units.map((unit, idx) => (
                  <>
                    <p>{String(unit.value).padStart(2, "0")}</p>
                    {idx < units.length - 1 && <p>:</p>}
                  </>
                ))}
              </div>
              <h5>Get Ready for Code Week 2025!</h5>
              <p>
                With Minecraft Education and coding, millions of young learners
                will unlock creativity, build problem-solving skills, and shape
                the innovations of tomorrow.
              </p>
            </div> */}
          </Grid2>
        </Grid2>
      </Container>
    </section>
  );
};

export default Banner;
